/**
 * Safely normalizes any error value into a consistent shape.
 * Uses safeError internally for bulletproof Safari compatibility.
 */
import { safeError, type SafeErrorInfo } from "./safeError";

export type NormalizedError = SafeErrorInfo;

export function normalizeError(err: unknown): NormalizedError {
  return safeError(err);
}
